import React from 'react';
import { createRoot } from 'react-dom/client';
import { Helmet } from 'react-helmet';
import { Global, css } from '@emotion/core';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';

import { normalize, global } from '@parapet/common';
import { AppRoutes } from './routes';
import { configureStore } from './store';
import { globalStyles } from './styles/global-styles';

if (
  process.env.REACT_APP_ENV !== 'local' &&
  process.env.REACT_APP_SENTRY_DSN
) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
  });
}

const store = configureStore();

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.Fragment>
    <Helmet titleTemplate="%s | Parapet Studios">
      <meta name="robots" content="noindex" />
    </Helmet>
    <Global styles={() => css(normalize, global, globalStyles)} />
    <Provider store={store}>
      <AppRoutes />
    </Provider>
  </React.Fragment>,
);
